module.exports = __webpack_public_path__ + "static/img/cgal15.d423d50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/cgal15.png
// module id = WiN2
// module chunks = 1